import { Box, Grid2 as Grid, styled } from "@mui/material";
import SurfaceSection from "../../../../components/Common/SurfaceSection";

export const ItemGrid = styled(Grid)(({ theme }) => `
    display: flex;
    height: auto;
    min-height: 0;
    
    ${theme.breakpoints.up('md')} {
        height: calc((100% - ${theme.spacing(2)}) / 2);
    }
`);

export const StyledMainGrid = styled(Grid)`
    height: 100%;
    min-height: 0;
    width: 100%;
`;

export const FormContentBox = styled(Box)(({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
    justify-content: space-between;
    height: 100%;
`);

export const EntityListBox = styled(SurfaceSection)(({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
    overflow: auto;
`);

export const EmptyStateWrapper = styled(Box)`
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 360px;
`;

export const EmptyStateCard = styled(Box)(({ theme }) => `
    align-items: center;
    background-color: ${theme.palette.background.paper};
    border: 1px dashed ${theme.palette.divider};
    border-radius: ${theme.shape.borderRadius}px;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
    justify-content: center;
    max-width: 420px;
    min-height: 260px;
    padding: ${theme.spacing(3)};
    text-align: center;
    width: 100%;
`);
